// import React, { createContext, useState, useContext, useEffect } from 'react';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [authState, setAuthState] = useState({
//     isAdminAuthenticated: false,
//     isLoading: false,
//   });

//   const adminLogin = async (token) => {
//     try {
//       localStorage.setItem('adminToken', token);
//       setAuthState((prev) => ({
//         ...prev,
//         isAdminAuthenticated: true,
//         isLoading: false,
//       }));
//       return true;
//     } catch (error) {
//       console.error('Admin login error:', error);
//       return false;
//     }
//   };

//   const logout = async () => {
//     try {
//       localStorage.removeItem('adminToken');
//       setAuthState({
//         isAdminAuthenticated: false,
//         isLoading: false,
//       });
//     } catch (error) {
//       console.error('Logout error:', error);
//     }
//   };

//   const checkAuthState = async () => {
//     try {
//       const adminToken = localStorage.getItem('adminToken');
//       if (adminToken) {
//         setAuthState((prev) => ({
//           ...prev,
//           isAdminAuthenticated: true,
//         }));
//       }
//     } catch (error) {
//       console.error('Auth state check error:', error);
//     }
//   };

//   useEffect(() => {
//     checkAuthState();
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{
//         isAdminAuthenticated: authState.isAdminAuthenticated,
//         isLoading: authState.isLoading,
//         login: adminLogin,
//         logout,
//         checkAuthState,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// auth/AuthContext.js - UPDATED
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAdminAuthenticated: false,
    isLoading: true, // Start with true to check auth status
    adminToken: null,
  });

  const adminLogin = async (token) => {
    try {
      localStorage.setItem('adminToken', token);
      setAuthState({
        isAdminAuthenticated: true,
        isLoading: false,
        adminToken: token,
      });
      return true;
    } catch (error) {
      console.error('Admin login error:', error);
      return false;
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem('adminToken');
      setAuthState({
        isAdminAuthenticated: false,
        isLoading: false,
        adminToken: null,
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const checkAuthState = async () => {
    try {
      const adminToken = localStorage.getItem('adminToken');
      console.log('Checking auth state, token:', adminToken ? 'Present' : 'Missing');
      
      if (adminToken) {
        // Optional: Validate token with backend
        setAuthState({
          isAdminAuthenticated: true,
          isLoading: false,
          adminToken: adminToken,
        });
      } else {
        setAuthState({
          isAdminAuthenticated: false,
          isLoading: false,
          adminToken: null,
        });
      }
    } catch (error) {
      console.error('Auth state check error:', error);
      setAuthState({
        isAdminAuthenticated: false,
        isLoading: false,
        adminToken: null,
      });
    }
  };

  useEffect(() => {
    checkAuthState();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAdminAuthenticated: authState.isAdminAuthenticated,
        isLoading: authState.isLoading,
        adminToken: authState.adminToken,
        login: adminLogin,
        logout,
        checkAuthState,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};